'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('iamAdminControllers', [])

.factory('iamAdminService', ['$http', function ($http) {

    var service = {};

    service.ignoreLastOpenedBatch = function () {
        return $http.post(environment.apiUrl + '/ID/Administration/PublisherEmployeurD/API/IgnoreLastOpenedBatch')
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}])

.controller('IamAdminController', ['$scope', '$translate', 'growl', 'iamAdminService', function ($scope, $translate, growl, iamAdminService) {

    // Get ID Url
    $scope.idUrl = environment.idUrl;

    // Ignore Last Opened Batch
    $scope.ignoreLastOpenedBatch = function () {
        return iamAdminService
                .ignoreLastOpenedBatch()
                .then(function (response) {
                    $translate('iam.shared.controllers.iamAdmin.batchIgnored').then(function(translation) {
                        growl.addSuccessMessage('<span class="gritter-title">' + translation + '</span>',
                                               { enableHtml: true, ttl: 1 });
                    });
                });
    };

}]);
